<template>
  <div class="row layout-navbar navbar navbar-expand-lg align-items-lg-center container-p-x bg-navbar-theme" id="layout-navbar" :class="applyInstituteTheme(institution.title)">
    <div class="col-3 user_menu">
      <b-nav-item-dropdown left v-if="!isTempUser">
        <!-- Using button-content slot -->
        <template slot="button-content">
          <span class="ic ic-menuHamburger"></span>
        </template>
        <span class="user_details row">
          <span class="col-2 user_ic" v-html="firstNameFirstChar"></span>
          <!--
          <img :src="profilePic" class="contact-content-img rounded-circle mb-2" alt="">
          -->
          <span class="col-9 contact-content-name user_name">{{firstName}} {{lastName}}</span>
          <!--
          <span class="col-1 close_btn_container">
            <span class="btn_close">
              <span class="ic-close"></span>
            </span>
          </span>
          -->
        </span>

        <template v-if="!isShowingTermAndCondition">
          <template v-if="isLearnerDashboardEnabled">

            <b-dropdown-item @click="partnerHomePage" v-if="(this.institution.partnerHomeUrl && this.institution.partnerHomeUrl.length>10)">
              <span class="ic_container">
                <span class="ic ic24-home"></span>
              </span>
              <span class="lnk_txt">
                {{ $t('home') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'modernDashboard'}" v-else-if="(this.institution.learnerDashboard && (this.institution.learnerDashboard.indexOf('modern')!=-1))">
              <span class="ic_container">
                <span class="ic ic24-home"></span>
              </span>
              <span class="lnk_txt">
                {{ $t('myHome') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'learnerDashboard'}" v-else>
              <span class="ic_container">
                <span class="ic ic24-home"></span>
              </span>
              <span class="lnk_txt">
                {{ $t('myHome') }}
              </span>
            </b-dropdown-item>

            <b-dropdown-item v-if="institutionCount > 1" :to="{name: 'institutionSwitch'}">
              <span class="ic_container">
                <span class="ic ic24-BuildingCollege"></span>
              </span>
              <span class="lnk_txt">
                {{ $t('myInstitutions') }}
              </span>
            </b-dropdown-item>

            <div class="row lnk_menu lnk_menu_footer sub_menu_container" v-if="isShowProgramsEnabled" :aria-label="getMyProgramsLabel">
              <button class="col-12 btn_lnk sub_menu_title" variant="primary" @click="showMyProgramsMenu">
                <span class="ic_container">
                  <span class="ic ico-degreeProgram ico-program"></span>
                </span>
                <span class="lnk_txt">{{getMyProgramsLabel}}</span>
                <span class="ic_container ic_container_inner">
                  <span class="ic ic-circle-right"></span>
                </span>
              </button>

              <div class="col-12 sub_menu_list" id="subMenu_MyProgram" v-if="myProgramsMenu">
                <div class="sub_menu_head">
                  {{ $t('enrolledPrograms') }}

                  <span class="close_btn_container">
                    <button class="ic ic-close" @click="hideMyProgramsMenu"></button>
                  </span>
                </div>
                <b-dropdown-item class="lnk_menu lnk_menu_footer" v-for="(pg, index) in learnerEnrollmentData">
                  <span class="lnk_txt" @click="showProgramHome(pg.programCode), hideMyProgramsMenu()">
                    {{pg.programTitle}}
                  </span>
                </b-dropdown-item>
              </div>

            </div>

            <template v-if="isMyProgressEnabled">
              <template v-if="learnerEnrollmentData.length > 0">
                <b-dropdown-item :to="{name: 'learnerProgramList'}">
                  <span class="ic_container">
                    <span class="ic ic24-progress"></span>
                  </span>
                  <span class="lnk_txt">
                    {{ $t('myProgress') }}
                  </span>
                </b-dropdown-item>
              </template>
              <template v-if="learnerEnrollmentData.length === 0">
                <b-dropdown-item @click="navigateToLearnerProgram">
                  <span class="ic_container">
                    <span class="ic ic24-progress"></span>
                  </span>
                  <span class="lnk_txt">
                    {{ $t('myProgress') }}
                  </span>
                </b-dropdown-item>
              </template>
            </template>
            <template v-if="isCalendarEnabled">
              <b-dropdown-item :to="{name: 'calendarEventList'}">
                <span class="ic_container">
                  <span class="ic ic24-dateRange"></span>
                </span>
                <span class="lnk_txt">
                  {{ $t('myCalendar') }}
                </span>
              </b-dropdown-item>
            </template>
            <b-dropdown-item :to="{name: 'learnerProfile', params: {uuid: userObj.uuid}}">
              <span class="ic_container">
                <span class="ic ic24-user"></span>
              </span>
              <span class="lnk_txt">
                {{ $t('myProfile') }}
              </span>
            </b-dropdown-item>
            <template v-if="isJobBoardEnabled">
              <b-dropdown-item :to="{name: 'myJobApplications'}">
                <span class="ic_container">
                  <span class="ic ic2_job-application"></span>
                </span>
                <span class="lnk_txt">
                  {{ $t('myJobApplications') }}
                </span>
              </b-dropdown-item>
            </template>
            <template v-if="isAcceptPaymentsEnabled">
              <b-dropdown-item :to="{name: 'purchases'}">
                <span class="ic_container">
                  <span class="ic ic24-dateRange"></span>
                </span>
                <span class="lnk_txt">
                  {{ $t('myPurchases') }}
                </span>
              </b-dropdown-item>
            </template>
            <template v-if="isAcceptPaymentsEnabled && isWalletEnabled">
              <b-dropdown-item :to="{name: 'wallet'}">
                <span class="ic_container">
                  <span class="ic ic24-buy"></span>
                </span>
                <span class="lnk_txt">
                  {{ $t('myWallet') }}
                </span>
              </b-dropdown-item>
            </template>
            <template v-if="isExplorePackageEnabled">
              <b-dropdown-item v-if="isBookmarkEnabled" :to="{name: 'bookmarks'}">
                <span class="ic_container">
                  <span class="ic ic24-bookmarks"></span>
                </span>
                <span class="lnk_txt">
                  {{ $t('bookmarks') }}
                </span>
              </b-dropdown-item>
              <span class="menu_head">{{ $t('explore') }}</span>
              <b-dropdown-item :to="{name: 'exploreCareerResults'}">
                <span class="ic_container">
                  <span class="ic ic24-career"></span>
                </span>
                <span class="lnk_txt">
                  {{ getExploreCareersLabel }}
                </span>
              </b-dropdown-item>
              <b-dropdown-item v-if="isEmployerBoardEnabled" :to="{name: 'employerBoard'}">
                <span class="ic_container">
                  <span class="ic ic2_employer"></span>
                </span>
                <span class="lnk_txt">
                  {{ getEmployerBoardLabel }}
                </span>
              </b-dropdown-item>
              <b-dropdown-item v-if="isJobBoardEnabled" :to="{name: 'jobBoard', params: { reload: true} }">
                <span class="ic_container">
                  <span class="ic ic2_job-briefcase"></span>
                </span>
                <span class="lnk_txt">
                  {{ getJobBoardLabel }}
                </span>
              </b-dropdown-item>
              <b-dropdown-item :to="{name: 'exploreProgramResults'}">
                <span class="ic_container">
                  <span class="ic ic24-degreeProgram"></span>
                </span>
                <span class="lnk_txt">{{ getExploreProgramsLabel }}</span>
              </b-dropdown-item>
            </template>
            <template v-else-if="isJobBoardEnabled">
              <b-dropdown-item :to="{name: 'jobBoard', params: { reload: true} }">
                <span class="ic_container">
                  <span class="ic ic2_job-briefcase"></span>
                </span>
                <span class="lnk_txt">
                  {{ getJobBoardLabel }}
                </span>
              </b-dropdown-item>
              <b-dropdown-item v-if="isEmployerBoardEnabled" :to="{name: 'employerBoard'}">
                <span class="ic_container">
                  <span class="ic ic2_employer"></span>
                </span>
                <span class="lnk_txt">
                  {{ getEmployerBoardLabel }}
                </span>
              </b-dropdown-item>
            </template>
            <template v-if="links.length>0">
              <span class="menu_head">{{getQuickLinksLabel}}</span>
              <b-dropdown-item v-for="(link, i) in links"  @click="launchQuickLink(link.url)"  v-if="i<showLinkSize">
                <span class="ic_container">
                  <span class="ic ic24-link"></span>
                </span>
                <span class="lnk_txt">{{link.title}}</span>
              </b-dropdown-item>
              <a href="javascript:void(0)" style="text-align: right; float: right; padding-right: 10px;" :aria-label="$t('showMoreAria', { label: getQuickLinksLabel })" v-if="links.length > showLinkSize" @click="showAllLink">
                {{ $t('more') }}
              </a>
              <a href="javascript:void(0)" style="text-align: right; float: right; padding-right: 10px;" :aria-label="$t('showLessAria', { label: getQuickLinksLabel })" v-if="showLinkSize>2 && links.length <= showLinkSize" @click="showLimitedLink">
                {{ $t('less') }}
              </a>
            </template>

          </template>
          <template v-else>
            <b-dropdown-item v-if="isDashboardEnabled" :to="{ name: 'dashboard' }">
              {{ $t('dashboard') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="isExplorePackageEnabled" :to="{ name: 'exploreIntro' }">
              {{ $t('explore') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="isJobBoardEnabled" :to="{ name: 'jobBoard', params: { reload: true} }">
              <span class="ic_container">
                <span class="ic ic2_job-briefcase"></span>
              </span>
              <span class="lnk_txt">
                {{ getJobBoardLabel }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item v-if="isEmployerBoardEnabled" :to="{ name: 'employerBoard' }">
              <span class="ic_container">
                <span class="ic ic2_employer"></span>
              </span>
              <span class="lnk_txt">
                {{ getEmployerBoardLabel }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item v-if="isJobBoardEnabled" :to="{ name: 'myJobApplications' }">
              <span class="ic_container">
                <span class="ic ic2_job-application"></span>
              </span>
              <span class="lnk_txt">
                {{ $t('myJobApplications') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item v-if="isExplorePackageEnabled && isBookmarkEnabled"  :to="{ name: 'bookmarks' }">
              <span class="ic_container">
                <span class="ic ic24-bookmarks"></span>
              </span>
              <span class="lnk_txt">
                {{ $t('bookmarks') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item v-if="planningStream && planningStream.uuid" :to="{ name: 'streamDegree', params: { uuid: planningStream.uuid } }">
              {{ $t('degreeProgress') }}
            </b-dropdown-item>
            <!--
            <li>
              <b-dropdown-item>Credit Progress</b-dropdown-item>
              <b-dropdown-item>Course Progress</b-dropdown-item>
            </li>
            -->
            <b-dropdown-item v-if="isSkillTaggingEnabled && planningStream && planningStream.uuid" :to="{ name: 'streamCareer', params: { uuid: planningStream.uuid } }">
              {{ $t('careerProgress') }}
            </b-dropdown-item>
            <!--
            <li>
              <b-dropdown-item v-if="isSkillTaggingEnabled">Skill Progress</b-dropdown-item>
              <b-dropdown-item v-if="isSkillTaggingEnabled">Skill Breakup</b-dropdown-item>
            </li>
            -->
            <b-dropdown-item :to="{ name: 'courses' }">
              {{ $t('courses') }}</b-dropdown-item>
            <!--
            <b-dropdown-item>Recommendations</b-dropdown-item>
            -->
            <b-dropdown-item :to="{ name: 'dataPrivacy', params: {userObj: userObj} }" v-if="isXprizeDataOptOutEnabled">
              {{ $t('dataOptOut') }}
            </b-dropdown-item>
          </template>
          <span class="menu_head">
            {{ $t('changeLanguage') }}
          </span>
          <b-dropdown-item
            class=""
            :class="{ lang_selected: $i18n.locale === 'en' }"
            tabindex="0"
            @click="changeLanguage('en')"
            :aria-label="$t('defaultLocaleEnglishAria')">
              {{ $t('languageEnglish') }}
          </b-dropdown-item>
          <b-dropdown-item class=""
            :class="{ lang_selected: $i18n.locale === 'es' }"
            tabindex="0"
            @click="changeLanguage('es')"
            :aria-label="$t('localeSpanishAria')">
              {{ $t('languageSpanish') }}
          </b-dropdown-item>
        </template>
        <span class="menu_btn_container">
          <button type="button" class="btn btn-primary" @click="logout">
            {{ $t('logout') }}
          </button>
        </span>
      </b-nav-item-dropdown>
      <template  v-if="!isLearnerDashboardEnabled && !isTempUser">
        <b-link class="lnk_explore" v-if="isExplorePackageEnabled && !isShowingTermAndCondition" :to="{ name: 'exploreIntro' }">
          <span class="ic ic-explore"></span>
        </b-link>
      </template>
    </div>
    <div class="col-6" style="padding: 0;">
      <b-link class="app-brand logo_container" style="text-align: center;">
        <!--
        <span class="app-brand-logo demo bg-primary">
          e
        </span>
        -->
        <img class="" :src="institution.logo">
      </b-link>
    </div>
    <div class="col-3">
      <!--
      <b-nav-item-dropdown right>
        <template slot="button-content">
          <span class="user_ic" v-html="firstNameFirstChar"></span>
        </template>

        <span class="user_details row">
          <span class="col-10 contact-content-name user_name">{{firstName}} {{lastName}}</span>
          <span class="col-2 user_ic" v-html="firstNameFirstChar"></span>
        </span>

        <span class="menu_btn_container">
          <button type="button" class="btn btn-primary" @click="logout">Log Out</button>
        </span>
      </b-nav-item-dropdown>
      -->
      <template v-if="isLearnerDashboardEnabled">
        <div class="channel-place">
          <b-button class="channel-btn" @click="navigateToChannel">
            <span class="channel-container">
              <i class="fas fa-comment ic11-channel"></i>
              <span v-if="unreadCountState > 0" class="notification-count">{{unreadCountState}}</span>
            </span>
          </b-button>
        </div>
      </template>
    </div>
    <div class="form_modal_popup">
      <b-modal class="h-100 d-inline-block" id="no-program-modal-popup" ref="noEnrolledProgramModal" size="lg" :header-bg-variant="'light'" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt float-left" style="width: 90%;">
            <span> {{ $t('message.notEnrolledInProgram') }} </span>
          </div>
          <div class="float-right">
            <button class="btn_close" :aria-label="$t('close')" @click="cancelNoEnrolledProgramModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div class="modal_content">
          <div class="row mb-4 mt-4">
            <div class="col-1"></div>
            <div class="col-11">
              <div class="row">
                <div class="col-12 mb-4">
                  <div v-if="showCourseMessage">
                    <span>{{ $t('noProgramCoursesInfo', { label: exploreProgramsLabel }) }}</span>
                  </div>
                  <div v-else>
                    <span>{{ $t('noProgramInfo', { label: exploreProgramsLabel }) }}</span>
                  </div>
                </div>
                <div class="col-12 mb-4">
                  <span>{{ $t('noProgramHighlightPrefix', { labelPlural: exploreProgramsLabelPlural }) }} <a href="javascript://" @click="homePageClicked">{{ $t('homePage') }}</a>. {{ $t('noProgramHighlightMiddle') }} <a href="javascript://" @click="exploreProgramsClicked">{{ $t('exploreAllAvailableLabel', { labelPlural: exploreProgramsLabelPlural }) }}</a> {{ $t('noProgramHighlightSuffix', { label: exploreProgramsLabel }) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { auth, db } from '../../../firebase'
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { setItem, getItem } from '../../../storage'

export default {
  name: 'navbar',
  data: () => {
    return {
      unreadList: [],
      pageToRedirect: '',
      showCourseMessage : false,
      isDropDownActive: false,
      institutionCount: 1,
      institutionMeta: {},
      userTransactions: [],
      myProgramsMenu: false,
      links: [],
      showLinkSize:2
    }
  },
  async created () {
    await this.authenticateUserOnFirebase()
    this.institutionCount = await this.getAllUserAccountCount()
  },
  mounted () {
    this.loadNavBar()
    this.loadUnreadList()
  },
  methods: {
    ...mapActions([
      'loadUserObj',
      'loadUserJwt',
      'loadAllChannels',
      'loadPlanningStream',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'loadLearnerEnrolledProgram',
      'updateUnread',
      'loadQuickLinks',
      'getAllUserAccountCount',
      'loadInstitutionMetaInfoForSelfRegistration',
      'loadUserTransactions'
    ]),
    async loadNavBar () {
      await this.loadUserObj()
      let res = await this.loadInstitutionDetail(this.userObj.institutionId)
      this.institutionMeta = await this.loadInstitutionMetaInfoForSelfRegistration(this.userObj.institutionId)
      this.links = await this.loadQuickLinks('QUICKLINK')
      let root = document.documentElement;
      root.style.setProperty("--TU__BaseTxtClr", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__BtnClrPri", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnTxtClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnHoverClrPri", this.institutionMeta.buttonHoverColor); //Button Hover Color
      root.style.setProperty("--TU__BtnTxtHoverClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnClrSec", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnHoverClrSec", this.institutionMeta.buttonHoverColor);  //Button Hover Color
      root.style.setProperty("--TU__LnkClrPri", this.institutionMeta.linkColor); // Link Color
      root.style.setProperty("--TU__LnkHoverClrPri", this.institutionMeta.linkHoverColor); // Link Hover Color
      root.style.setProperty("--TU__LnkClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__LnkHoverClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      await this.loadInstitutionPackage({uuid: res.uuid, isAggregated: false})
      await this.loadAllChannels()
      await this.loadPlanningStream()
      this.userTransactions = await this.loadUserTransactions()
    },
    showMyProgramsMenu () {
      this.myProgramsMenu = !this.myProgramsMenu
    },
    hideMyProgramsMenu () {
      this.myProgramsMenu = false
    },
    launchQuickLink(url){
        window.open(url, '_blank')
    },
    showAllLink () {
      this.showLinkSize = this.links.length
    },
    showLimitedLink () {
      this.showLinkSize = 2
    },
    showProgramHome (code){
        setItem('dashboardProgram', code)
        var routerParams = {}
        return this.$router.push({name: 'modernDashboard', params: routerParams, query: {code: code}})
    },
    authenticateUserOnFirebase () {
      this.loadUserJwt().then(res => {
        auth.signInWithCustomToken(res)
      })
    },
    applyInstituteTheme (titleVal) {
      if(titleVal){
        let instTitle = titleVal.replace(/\s/g, '');
        $('body').addClass(instTitle)
      }
    },
    showHideDropDown () {
      this.isDropDownActive = !this.isDropDownActive
    },
    goToHomePage () {
      return this.$router.push({ name: 'dashboard' })
    },
    logout () {
      return this.$router.push({ name: 'logout' })
    },
    navigateToProfile () {
      return this.$router.push({name: 'learnerProfile', params: {uuid: this.userObj.uuid}})
    },
    navigateToLearnerProgram () {
      if (this.learnerDashboardState.enrollInProgram) {
        this.loadLearnerEnrolledProgram().then(programGuide => {
          this.navigateToProgramIntro(programGuide)
        })
      } else {
        this.pageToRedirect = 'INTRO'
        this.showCourseMessage = false
        this.$refs.noEnrolledProgramModal.show()
      }
    },
    navigateToLearnerCourses () {
      if (this.learnerDashboardState.enrollInProgram) {
        this.loadLearnerEnrolledProgram().then(programGuide => {
          this.navigateToProgramRequirement(programGuide)
        })
      } else {
        this.pageToRedirect = 'REQUIREMENT'
        this.showCourseMessage = true
        this.$refs.noEnrolledProgramModal.show()
      }
    },
    cancelNoEnrolledProgramModal () {
      this.pageToRedirect = ''
      this.selectedProgramInterest = {}
      this.$refs.noEnrolledProgramModal.hide()
    },
    navigateToProgramIntro (programGuide) {
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type
      }
      return this.$router.push({name: 'programGuideMenu', params: routerParams, query: {returnTo: 'learnerDashboard', pageTitle: this.$t('backToLearnerDashboard')}})
    },
    navigateToProgramRequirement (programGuide) {
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type
      }
      return this.$router.push({name: 'programGuideRequirements', params: routerParams, query: {returnTo: 'learnerDashboard', pageTitle: this.$t('backToLearnerDashboard')}})
    },
    exploreProgramsClicked () {
      this.cancelNoEnrolledProgramModal()
      setTimeout(() => {
        return this.$router.push({name: 'exploreProgramResults'})
      }, 0)
    },
    homePageClicked () {
      this.cancelNoEnrolledProgramModal()
      setTimeout(() => {
        return this.$router.push({name: 'learnerDashboard'})
      }, 0)
    },
    loadUnreadList () {
      let userId = this.userObj.uuid
      this.$bindAsArray('unreadList', db.ref('Unread/' + userId))
    },
    partnerHomePage () {
        window.location.href = this.institution.partnerHomeUrl
    },
    navigateToChannel () {
      return this.$router.push({name: 'channel', params: {uuid: this.userObj.uuid, channelType: 'ALL'}})
    },
    closeSubmenuIfClickedOutside(event) {
      if (!document.getElementById('myProgramsMenu').contains(event.target)) {
        this.myProgramsMenu = false;
        document.removeEventListener('click', this.closeSubmenuIfClickedOutside);
      }
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang; // Change the language dynamically
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'isTempUser': state => state.login.tempUser,
      'myChannels': state => state.dashboard.channels,
      'unreadCountState': state => state.dashboard.unreadCountState,
      'institution': state => state.dashboard.institution,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'planningStream': state => state.dashboard.stream,
      'learnerDashboardState': state => state.dashboard.learnerDashboardState,
      'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
    }),
    isWalletEnabled () {
      if (this.userTransactions && this.userTransactions.length > 0) {
        for (var i = 0; i < this.userTransactions.length; i++) {
          let item = this.userTransactions[i]
          if (item.subscriptionId !== "") {
            console.log("Subscription found")
            return true
          }
        }
      }
      return false
    },
    isShowingTermAndCondition () {
      return (this.$route.path === '/termsAndConditions')
    },
    firstNameFirstChar () {
      if (this.userObj && this.userObj.firstName) {
        return this.userObj.firstName.charAt(0).toUpperCase()
      } else {
        return ''
      }
    },
    firstName () {
      if (this.userObj) {
        return this.userObj.firstName
      } else {
        return ''
      }
    },
    lastName () {
      if (this.userObj) {
        return this.userObj.lastName
      } else {
        return ''
      }
    },
    role () {
      if (this.userObj && this.userObj.roles.length > 0) {
        return this.userObj.roles[0].role
      } else {
        return ''
      }
    },
    profilePic () {
      return '/images/neutral-small.png'
    },
    isShowProgramsEnabled () {
      let showProgramsMenu = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_MY_PROGRAMS_MENU]
      return (showProgramsMenu && showProgramsMenu.enabled)
    },
    getMyProgramsLabel () {
      let showProgramsMenu = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_MY_PROGRAMS_MENU]
      return showProgramsMenu ? showProgramsMenu.label : this.$t('myPrograms')
    },
    getQuickLinksLabel () {
      let quickLinks = this.enabledFeatures['quick_links']
      return quickLinks && quickLinks.label ? quickLinks.label : this.$t('quickLinks')
    },

    isSkillTaggingEnabled () {
      let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
      if (skillTaggingFeature) {
        return skillTaggingFeature.enabled
      }
      return false
    },
    isExplorePackageEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isBookmarkEnabled () {
      let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
      if (bookmarkFeature && bookmarkFeature.enabled) {
        return true
      }
      return false
    },
    isAcceptPaymentsEnabled () {
      let acceptPayments = this.enabledFeatures[PACKAGE.FEATURE_IDS.PAYMENT_INTEGRATION]
      if (acceptPayments && acceptPayments.enabled) {
        return true
      }
      return false
    },
    isCalendarEnabled () {
      let calendar = this.enabledFeatures[PACKAGE.FEATURE_IDS.CALENDAR]
      if (calendar && calendar.enabled) {
        return true
      }
      return false
    },
    isJobBoardEnabled () {
      let jobBoard = this.enabledFeatures[PACKAGE.FEATURE_IDS.JOB_BOARD]
      if (jobBoard && jobBoard.enabled) {
        return true
      }
      return false
    },
    getJobBoardLabel () {
      let jobBoard = this.enabledFeatures[PACKAGE.FEATURE_IDS.JOB_BOARD]
      if (jobBoard && jobBoard.label) {
        return jobBoard.label
      }
      return this.$t('exploreJob')
    },
    getExploreProgramsLabel () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (feature && feature.label) {
        return feature.label
      }
      return this.$t('explorePrograms')
    },
    getExploreCareersLabel () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_CAREERS]
      if (feature && feature.label) {
        return feature.label
      }
      return this.$t('exploreCareers')
    },


    isEmployerBoardEnabled () {
      let jobBoard = this.enabledFeatures[PACKAGE.FEATURE_IDS.JOB_BOARD]
      if (jobBoard && jobBoard.enabled) {
        let flags = jobBoard.flags || []
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === PACKAGE.FEATURE_IDS.EMPLOYER_BOARD) {
            return flag.enabled
          }
        }
      }
      return false
    },
    getEmployerBoardLabel () {
      let jobBoard = this.enabledFeatures[PACKAGE.FEATURE_IDS.JOB_BOARD]
      if (jobBoard && jobBoard.enabled) {
        let flags = jobBoard.flags || []
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === PACKAGE.FEATURE_IDS.EMPLOYER_BOARD && flag.label) {
            return flag.label
          }
        }
      }
      return this.$t('exploreEmployer')
    },
    isMyProgressEnabled () {
      let programDetailFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
      if (programDetailFeature && programDetailFeature.enabled) {
        let flags = programDetailFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'allowEnrollment') {
            return flag.enabled
          }
        }
      }
      return false
    },
    isDashboardEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature) {
        return progressViewFeature.enabled
      }
      return false
    },
    isLearnerDashboardEnabled () {
      let learnerDashboardFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_LEARNER_DASHBOARD_FEATURE_ID]
      if (learnerDashboardFeature) {
        return learnerDashboardFeature.enabled
      }
      return false
    },
    isXprizeDataOptOutEnabled () {
      let xprizeDataOptOutFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_XPRIZE_DATA_OPT_OUT]
      if (xprizeDataOptOutFeature) {
        return xprizeDataOptOutFeature.enabled
      }
      return false
    },
    isChannelAvailable () {
      return (this.myChannels && this.myChannels.length > 0)
    },
    exploreProgramsLabel () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
       if (exploreFeature) {
         for (var i = 0; i < exploreFeature.flags.length; i++) {
           if (exploreFeature.flags[i].title === 'useProgramLongText') {
             if (exploreFeature.flags[i].isEnabled) {
               return exploreFeature.flags[i].label
             }
           }
         }
       }
       return this.$t('program')
   },
   exploreProgramsLabelPlural () {
     let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature) {
        for (var i = 0; i < exploreFeature.flags.length; i++) {
          if (exploreFeature.flags[i].title === 'useProgramLongText') {
            if (exploreFeature.flags[i].isEnabled) {
              return exploreFeature.flags[i].label + 's'
            }
          }
        }
      }
      return this.$t('programs')
   }
  },

  watch: {
    unreadList (newUnreadList) {
      newUnreadList.forEach(data => {
        this.updateUnread({channelId: data.channelId, unread: data.unreadCount})
      })
    },
    dropOpen(myProgramsMenu) {
      if (myProgramsMenu) {
        document.addEventListener('click', this.closeSubmenuIfClickedOutside)
      }
    }
  }
}
</script>

<style>
  .nav-logo {
    width: 60px;
  }
  .img-small {
    height: 50px;
  }
  .menu_head {
    text-align: center;
    padding: 12px 20px 12px 0;
    color: #fff;
    background: #636363;
    width: 100%;
    float: left;
    font-size: 18px;
    font-weight: 400;
  }
  .channel-container {
    top: -2px;
    right: 10px;
    position: absolute;
  }
  .navbar .ic11-channel {
    font-size: 42px;
  }
  .unread-count {
    position: absolute;
    bottom: 10px;
    left: 12px;
    color: #fff;
    font-size: 17px;
  }
</style>



// WEBPACK FOOTER //
// src/app/misc/components/Navbar.vue